import { collection, getDocs, query, where } from "firebase/firestore"
import { db } from "../Config/Firebase-config";

export const fetchBanner = async () => {
    try {
        const querry = query(collection(db, "banners"));
        const querySnapshot = await getDocs(querry);
        const BannerList = querySnapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
        }));
        return BannerList;
    }catch(error){
        console.error("Error retrieving data: ", error.message);
    }
}